import { createMask } from '../components/phone';
import { Metrika } from '../components/metrika';
import { Analytics } from '../components/analytics';
import { default as Form } from '../components/form';

export function feedback() {
    let metrika = new Metrika;
    let analytics = new Analytics;

    let phonesInputs = document.querySelectorAll('[data-phoneMask]');
    phonesInputs.forEach( function(item) {
        createMask(item)
    });

    let inputs = document.querySelectorAll('[am-input]');
    let formError = document.querySelectorAll('[am-error]');
    inputs.forEach( function(item) {
        item.addEventListener('input', function() {
            item.classList.remove('error');

            formError.forEach( function(item) {
                item.classList.remove('is-active');
            });
        });
    });

    function ShowThanksModal() {
        let modal = document.querySelector('.Modal-thanks');
        let modalClose = document.querySelectorAll('.Modal__close');
        modal.classList.add('is-active');
        setTimeout(() => {
            modal.style.opacity = 1;
        }, 300);

        modal.addEventListener('click', (event) => {
            modalClose.forEach(function(item) {
                if (modal.classList.contains('is-active') && event.target == item) {
                    modal.style.opacity = 0;
                    setTimeout(() => {
                        modal.classList.remove('is-active');
                    }, 300);
                }
            });
        });
    }

    new Form('js-FeedbackForm', {
        url: '/feedback/handler',
        statusOk: function(form) {
            if (form.classList.contains('js-FeedbackTestForm')) {
                metrika.reachGoal('TEST_FORM_END_YES');
                analytics.event('TEST_FORM_END');
            } else {
                metrika.reachGoal('B24_FORM_2_END');
                analytics.event('B24_FORM_2_END');
            }

            let activeModal = document.querySelector('.Modal.is-active');
            if (activeModal) {
                activeModal.classList.remove('is-active');
                let html = document.getElementsByTagName('html');
                if (html[0]) {
                    html[0].style.overflow = null;
                }
                let body = document.getElementsByTagName('body');
                if (body[0]) {
                    body[0].style.overflow = null;
                }
            }

            ShowThanksModal();
        },
        afterResponse: function(form) {
            if (form.classList.contains('js-FeedbackTestForm')) {
                form.addEventListener('keydown', function(event) {
                    metrika.reachGoal('TEST_FORM_START', this);
                    analytics.event('TEST_FORM_START', this);
                });
                form.elements.name.addEventListener('change', function(event) {
                    metrika.reachGoal('TEST_FORM_NAME', this);
                    analytics.event('TEST_FORM_NAME', this);
                });
                form.elements.tel.addEventListener('change', function(event) {
                    metrika.reachGoal('TEST_FORM_PHONE', this);
                    analytics.event('TEST_FORM_PHONE', this);
                });
            } else {
                form.addEventListener('keydown', function(event) {
                    metrika.reachGoal('B24_FORM_2_START', this);
                    analytics.event('B24_FORM_2_START', this);
                });
                form.elements.name.addEventListener('change', function(event) {
                    metrika.reachGoal('B24_FORM_2_CONTACT_NAME', this);
                    analytics.event('B24_FORM_2_CONTACT_NAME', this);
                });
                form.elements.tel.addEventListener('change', function(event) {
                    metrika.reachGoal('B24_FORM_2_CONTACT_PHONE', this);
                    analytics.event('B24_FORM_2_CONTACT_PHONE', this);
                });
            }
        }
    });

    let modal_open_buttons = document.querySelectorAll('[data-open="feedback"]');
    if (modal_open_buttons.length > 0) {
        for (let i = 0; i < modal_open_buttons.length; i++) {
            modal_open_buttons[i].addEventListener('click', function(event) {

                var title = event.target.getAttribute('data-modal-title');

                if (title) {
                    document.querySelector('[data-modal="feedback"] [am-title="feedback"]').innerText = title;
                } else {
                    document.querySelector('[data-modal="feedback"] [am-title="feedback"]').innerText = "Получите бесплатную консультацию";
                }

                metrika.reachGoal('B24_FORM_2_VIEW');
                analytics.event('B24_FORM_2_VIEW');
            });
        }
    }

    function modalOpen() {
        let modal = document.querySelector('.Modal');
        let modalClose = document.querySelectorAll('.Modal__close');
        modal.classList.add('is-active');
        setTimeout(() => {
            modal.style.opacity = 1;
        }, 300);

        modal.addEventListener('click', (event) => {
            modalClose.forEach(function(item) {
                if (modal.classList.contains('is-active') && event.target == item) {
                    modal.style.opacity = 0;
                    setTimeout(() => {
                        modal.classList.remove('is-active');
                    }, 300);
                }
            });
        });
    }


}
